import moment from "moment/moment";
import { forEach } from "lodash";

//Left Foot Position
export function getChartPositionOptions(
  positionPillBottle,
  showClosePillBottle
) {
  if (!positionPillBottle) {
    return;
  }
  //usertime
  let dateList = positionPillBottle.map(function(item) {
    return item.usertime
      ? moment(item.usertime.replace("Z", "")).format("MM/DD HH:mm:ss")
      : "-";
  });

  //left gsensor
  let gsensorX = positionPillBottle.map(function(item) {
    return item.gsensorx;
  });
  let gsensorY = positionPillBottle.map(function(item) {
    return item.gsensory;
  });
  let gsensorZ = positionPillBottle.map(function(item) {
    return item.gsensorz;
  });

  let gsensorColor = ["#529DE1", "#9AC078", "#7472AF"];

  let data_area = [];
  let color_area = [];
  let pill_status = positionPillBottle.map(item => {
    if (showClosePillBottle && item.onoff === "0") {
      return "on";
    } else if (!showClosePillBottle && item.onoff === "1") {
      return "off";
    }
    return "-";
  });
  let close_area = [];
  let start = false;
  let startIndex = 0;
  let endIndex = 0;
  forEach(pill_status, function(item, k) {
    if (item !== "-") {
      if (!start) {
        start = true;
        startIndex = k;
        if (k === pill_status.length - 1) {
          start = false;
          endIndex = k;
          close_area.push([startIndex, endIndex]);
        }
      } else {
        if (k === pill_status.length - 1) {
          start = false;
          endIndex = k;
          close_area.push([startIndex, endIndex]);
        }
      }
    } else {
      if (start) {
        start = false;
        endIndex = k - 1;
        close_area.push([startIndex, endIndex]);
      }
    }
  });
  forEach(close_area, function(item) {
    data_area.push([
      { name: showClosePillBottle ? "0" : "1", xAxis: dateList[item[0]] },
      { xAxis: dateList[item[1]] }
    ]);
    color_area.push("rgba(148, 0, 211, 0.1)");
  });

  return {
    tooltip: {
      trigger: "axis",
      showDelay: 0,
      textStyle: {
        align: "left"
      },
      position: function(point, params, dom, rect, size) {
        // The reference coordinate system of the mouse coordinates and the position of the prompt box is: the point in the upper left corner of the outer layer div is the origin, the x axis is right, and the y axis is down.
        let x = 0; // X position
        let y = 0; // Y position

        // Current position
        let pointX = point[0];

        // Outer view size
        let viewWidth = size.viewSize[0];

        // Tooltip size
        let boxWidth = size.contentSize[0];
        let boxHeight = size.contentSize[1];

        // boxWidth > viewWidth - pointX:  right side of the mouse can not put a prompt box
        if (boxWidth >= viewWidth - pointX) {
          x = pointX - boxWidth - 20;
        } else {
          x = pointX + 20;
        }

        y = (330 - boxHeight) / 2;

        return [x, y];
      }
    },
    color: [...gsensorColor],
    legend: [
      {
        data: ["gsensorX", "gsensorY", "gsensorZ"],
        top: "15%",
        left: 50,
        x: "left"
      }
    ],
    toolbox: {
      show: false,
      feature: {
        dataZoom: {
          yAxisIndex: "none"
        },
        restore: {},
        saveAsImage: {}
      }
    },
    dataZoom: [
      {
        orient: "horizontal",
        x: 0,
        y: -100,
        show: true,
        realtime: true,
        start: 10,
        end: 100,
        top: "4%",
        left: 100,
        right: 100
      }
      // {
      //   id: "dataZoomX",
      //   type: "inside",
      //   xAxisIndex: [0],
      //   filterMode: "none",
      //   start: 0,
      //   end: 10
      // }
    ],
    grid: [
      {
        left: 40,
        right: 40,
        tooltip: {
          trigger: "axis"
        }
      }
    ],
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        axisLine: {
          onZero: false,
          lineStyle: {
            color: "#C9CeD1",
            width: 1.5
          }
        },
        data: dateList,
        position: "bottom",
        axisLabel: {
          interval: 5000,
          textStyle: {
            color: "#000"
          }
        },
        axisTick: {
          show: false
        }
      }
    ],
    yAxis: [
      {
        name: "Position",
        type: "value",
        axisLabel: {
          formatter: function(data) {
            return Math.abs(data);
          }
        },
        axisLine: { onZero: true, show: false },
        inverse: false,
        splitLine: {
          show: true,
          lineStyle: {
            color: "#F1F1F1",
            width: 1,
            type: "dashed"
          }
        },
        axisTick: {
          show: false
        },
        nameTextStyle: {
          fontWeight: "bold",
          fontSize: "14",
          padding: [0, 10, 5, 0]
        }
      }
    ],
    series: [
      {
        name: "gsensorX",
        type: "line",
        xAxisIndex: 0,
        yAxisIndex: 0,
        symbolSize: 8,
        hoverAnimation: false,
        data: gsensorX,
        symbol: "none",
        itemStyle: {
          normal: {
            lineStyle: {
              color: "#4E9FE4"
            }
          }
        },
        markArea: {
          data: data_area,
          itemStyle: {
            normal: {
              color: color_area
            }
          },
          label: {
            normal: {
              show: true,
              position: "insideTop",
              verticalAlign: "top",
              opacity: 1,
              padding: 20
            }
          }
        }
      },
      {
        name: "gsensorY",
        type: "line",
        xAxisIndex: 0,
        yAxisIndex: 0,
        symbolSize: 8,
        hoverAnimation: false,
        data: gsensorY,
        symbol: "none",
        itemStyle: {
          normal: {
            lineStyle: {
              color: "#9AC177"
            }
          }
        }
      },
      {
        name: "gsensorZ",
        type: "line",
        xAxisIndex: 0,
        yAxisIndex: 0,
        symbolSize: 8,
        hoverAnimation: false,
        data: gsensorZ,
        symbol: "none",
        itemStyle: {
          normal: {
            lineStyle: {
              color: "#ac89c4"
            }
          }
        }
      }
    ]
  };
}
